import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { splitwiseAPI } from '../services/api';

const SplitwiseCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      setError('No authorization code received');
      return;
    }

    splitwiseAPI
      .handleCallback(code)
      .then(() => {
        navigate('/profile', { state: { splitwiseConnected: true } });
      })
      .catch((err) => {
        console.error('Splitwise callback error:', err);
        setError('Failed to connect Splitwise. Please try again.');
      });
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
        <div className="text-center">
          <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-6 h-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <p className="text-slate-900 font-medium mb-2">Connection Failed</p>
          <p className="text-slate-500 text-sm mb-4">{error}</p>
          <button
            onClick={() => navigate('/profile')}
            className="text-green-600 font-medium text-sm"
          >
            Back to Profile
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-8 h-8 border-4 border-slate-200 border-t-green-600 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-500">Connecting to Splitwise...</p>
      </div>
    </div>
  );
};

export default SplitwiseCallback;
